import _ from "lodash";
import draftToHtml from "draftjs-to-html";
import { formatDateRange } from "../../utils/formatDate";
import { fetchApi, toObject } from "../../utils";

const mapField = item => {
  return {
    ...item,
    id: _.get(item, "id"),
    image: _.get(item, "image.full_file_path"),
    description: _.reduce(
      _.get(item, "description"),
      (result, value, language) => {
        return {
          ...result,
          [language]: draftToHtml(value)
        };
      },
      {}
    ),
    title: _.get(item, 'title'),
    date: formatDateRange(_.get(item, 'event_start_time'), _.get(item, 'event_end_time')),
    post_category: _.get(item, 'post_category'),
  };
};

const fetchPostApi = () => {
  return fetchApi("posts")
    .then(res => _.get(res, "data"))
    // .then(mapField);
    .then(items => _.map(items, mapField))
    .then(toObject);
};

export { fetchPostApi };



// WEBPACK FOOTER //
// ./src/services/page/post.js